import React, { useState, useEffect } from "react";
import Navbar7 from "./../Navbar/Navbar7";
import { Link } from "react-scroll";

function Header7() {
  const [fixHeader, setFixed] = useState(false);

  useEffect(() => {
    const onScroll = () => setFixed(window.scrollY > 60);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <Link
        to="home"
        id="totop"
        className={fixHeader ? "d-block" : "d-none"}
        smooth={false}
        duration={800}
      >
        <i className="ion-ios-arrow-thin-up"></i>
      </Link>
      <header id="header" className={fixHeader ? "header-top-fixed" : ""}>
        <div className="full-screen-block">
          <div
            className={
              fixHeader ? "header-body header-body-fixed" : "header-body"
            }
            id="header-body-fixed"
          >
            <div id="container-fixed">
              <Navbar7 />
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header7;
